export default function (routeNumber) {
	switch (routeNumber) {
		case "1":
		case 1:
		case "2":
		case 2:
			return "bg-danger text-white";
			break;
		case "3":
		case 3:
			return "bg-light text-dark";
			break;
		case "4":
		case 4:
		case "5":
		case 5:
			return "bg-primary text-white";
			break;
		case "0":
		case 0:
		default:
			return "bg-success text-white";
			break;
	}
}
